<template>
  <div class="table-wrapper">
    <div class="table-base">
      <header>
        <template>
          <slot name="header"></slot>
        </template>
      </header>
      <el-table
        :data="tableData"
        stripe
        class="el_table"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="tableHeaderColor"
        :row-style="tableRowStyle"
        ref="tableData"
      >
        <template>
          <slot name="table"></slot>
        </template>
      </el-table>
    </div>
    <div class="block" v-if="showPagiantion">
      <el-pagination
        class="center-pg"
        v-loading="loading"
        background
        :current-page.sync="pageNo"
        @current-change="handleCurrentChange"
        :page-size="cpPageSize"
        layout="total, prev, pager, next"
        :total="len"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  props: {
    tableData: {
      type: Array,
    },
    len: {
      type: Number,
    },
    pageNum: "",
    pageSize: "",
    pageName: "",
    rowStyle: "",
    titleStyle: "",
    loading: false,
  },
  data() {
    return {
      showPagiantion: false,
      pageNo: 1,
      height: 400,
      cpPageSize: "10",
    };
  },
  watch: {
    len(newVal) {
      console.log(this.len);
      this.len = newVal;
      //   this.showPagiantion = this.len > this.cpPageSize ? true : false
      this.showPagiantion = true;
    },
    loading(newVal) {
      this.loading = newVal;
    },
    pageNum(newVal) {
      console.log(newVal);
      this.pageNo = newVal;
    },
    pageSize: {
      handler(newVal) {
        this.cpPageSize = newVal ? newVal : 10;
      },
      immediate: true,
    },
    height(newVal) {
      this.height = newVal;
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.pageNo = val;
      this.$emit("page-change", val); // 传递val请求分页数据
      console.log(`当前页: ${val}`);
    },
    storageCurrentPage() {
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem(this.pageName, this.pageNo);
      });

      var currentPage = sessionStorage.getItem(this.pageName);
      if (currentPage) {
        // 一定要把缓存中的currentPage传递出去,不然外层pageNo就是初始值
        this.$emit("currentpage-change", currentPage);
        this.pageNo = Number(currentPage);
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      // return this.rowStyle;
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    setTabHeight() {
      console.log(this.$refs.tableData);
      // this.height = sessionStorage.getItem("screenHeight") * 0.6;
      // this.$refs.tableData.setAttribute(
      //   "height",
      //   sessionStorage.getItem("screenHeight") * 0.6
      // );
    },
  },
  mounted() {
    this.storageCurrentPage();
    this.setTabHeight();
  },
  beforeDestroy() {
    this.pageNo = 1;
    sessionStorage.removeItem(this.pageName); //不在第一页时离开当前页--下次进来就是从第一个开始展示
  },
};
</script>
<style lang="scss" scoped>
.el_table {
  ::v-deep .el-table__body-wrapper {
    // background: grey;
    overflow-y: auto;
  }
}

.table-wrapper {
  .table-base {
    //padding: 20px;
    // min-height:calc(83vh); //sticky布局
    box-sizing: border-box;
  }
  .block {
    margin: 0;
    padding: 30px 0;
    background: #fff;
    .center-pg {
      display: inline-block;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
